module.exports = __webpack_public_path__ + "media/sales_marketing_strategies/bidding_photo_02-a6489e84.webp";